import { Outlet } from "react-router-dom";
import "./corporateLayout.css";
import CorporateSidebar from "../Components/CorporateSidebar";
import SecondaryNavbar from "../Components/Navbar02";
import { useState } from "react";
import Navbar from "../Components/Navbar01";

export default function CorporateDashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <>
      <Navbar />
      <SecondaryNavbar inDashboard={true} />
      <div className="layout-container">
        <CorporateSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div className={`layout-content ${collapsed ? "collapsed" : "expanded"}`}>
        <Outlet
        //   context={{
        //     userData,
        //     members,
        //     bloodSugarData,
        //     cholesterolData,
        //     hemoglobinData,
        //   }}
        />
      </div>
    </>
  );
}
